import { Box } from '@mui/material';

export const CheckIcon = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        width: 16,
        height: 16,
        borderRadius: '50%',
        backgroundColor: 'greens.lightest',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <svg width="11" height="9" viewBox="0 -1 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2.97154 7.92125L2.9678 7.91755L0.146446 5.09619C-0.0488157 4.90093 -0.0488153 4.58435 0.146447 4.38909L0.853554 3.68198C1.04882 3.48672 1.3654 3.48672 1.56066 3.68198L3.32845 5.44977L8.63177 0.146447C8.82703 -0.0488155 9.14361 -0.0488156 9.33887 0.146447L10.046 0.853553C10.2412 1.04882 10.2412 1.3654 10.046 1.56066L3.68202 7.92462C3.48676 8.11988 3.17017 8.11988 2.97491 7.92462L2.97154 7.92125Z"
          fill="#008254"
        />
      </svg>
    </Box>
  );
};
